import { useEffect, useState } from "react";
import { getUserByIdApi } from "../../services/user/userService";
import { getUserId } from "../../utils/authToken";

// 🔥 GLOBAL CACHE (outside React)
let cachedUser: any = null;
let isLoaded = false;

export const useProfileViewModel = () => {
  const [user, setUser] = useState<any>(cachedUser);
  const [loading, setLoading] = useState(false);

  const loadProfile = async () => {
    const userId = getUserId();
    if (!userId) return;

    setLoading(true);

    try {
      const res = await getUserByIdApi(userId);

      if (res.flag) {
        cachedUser = res.item;   // 🔥 save globally
        setUser(res.item);
        isLoaded = true;
      }
    } catch {
      // optional toast
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // 🔥 prevent duplicate calls globally
    if (isLoaded) return;

    loadProfile();
  }, []);

  return {
    user,
    loading,
  };
};